import { Fragment }                from 'react';
import { useCallback }             from 'react';
import { useFacebookAccessToken  } from './facebook_auth';
import { useFacebookClient }       from './facebook_auth';
import { useFacebookPagesList }    from './facebook_auth';
import FacebookAuth                from './facebook_auth';
import React                       from 'react';
import Swal                        from 'sweetalert2';


export default function ChoosePageView({
  business,
  statuses,
  saveFacebookPage,
  navigateBackTo,
  progressStart,
  progressEnd
}) {

  const save = useCallback(async(pageID, accessToken) => {
    try {
      await saveFacebookPage({
        pageID,
        accessToken
      });

      navigateBackTo(`/${business.id}/settings/business_profile/facebook`);
      Swal.fire({
        text: 'Your page has been connected!',
        icon: 'success'
      });

    } catch (error) {
      // showing the error is handled by the saveFacebookPage action
      // but the thrown error prevents our navigate call, which is good
    }
  }, [ business.id, navigateBackTo, saveFacebookPage ]);

  return (
    <FacebookAuth>
      <FacebookAuth.SignedOut>
        <AnonymousView/>
      </FacebookAuth.SignedOut>
      <FacebookAuth.SignedIn>
        <AuthedView {...{
          business,
          statuses,
          save,
          progressStart,
          progressEnd
        }}/>
      </FacebookAuth.SignedIn>
    </FacebookAuth>
  );
}

function AnonymousView() {
  const FB = useFacebookClient();

  function onClickSignIn() {
    FB.login(() => {}, { scope: 'manage_pages' });
  }

  return (
    <Fragment>
      <div className="list block inset">
        <h3>Facebook</h3>
        <p>Connect your Facebook page to your Broadly account to manage your business listing, receive real-time reviews, and more.</p>
      </div>
      <div className="list block inset facebook-signin">
        <p>
          <button className="button button-fill" onClick={onClickSignIn}>
            Sign in with your Facebook Account
          </button>
        </p>
      </div>
    </Fragment>
  );
}

function AuthedView({
  statuses,
  save,
  progressStart,
  progressEnd
}) {
  const [ pages, pagesStatus ] = useFacebookPagesList({ progressStart, progressEnd });

  if (pagesStatus === 'pending')
    return null;

  if (pagesStatus === 'failed')
    return <PageListFailedView/>;

  if (!pages.length)
    return <NoPagesView/>;

  return (
    <Fragment>
      <PageListView {...{ pages, save, statuses }}/>
      <OtherChoicesWithTitle/>
    </Fragment>
  );
}

function PageListView({ pages, save, statuses }) {
  const { updateStatus } = statuses;
  const { pending }      = updateStatus;

  return (
    <div className="list media-list block inset page-chooser">
      <div className="list-group">
        <ul>
          <li className="list-group-title">Choose your page:</li>
          {pages.map(page => <PageItemView key={page.id} {...{ page, save, pending }}/>)}
        </ul>
      </div>
    </div>
  );
}

function PageItemView({ page, save, pending }) {
  const accessToken = useFacebookAccessToken();
  const { name }    = page;

  function onClick() {
    save(page.id, accessToken);
  }

  return (
    <li>
      <div className="item-content">
        <div className="item-inner">
          <div className="item-title-row">
            <div className="item-title">
              {name}
            </div>
          </div>
        </div>
      </div>
      <div className="item-after">
        <button className="button button-fill" disabled={pending} onClick={onClick}>
          Connect
        </button>
      </div>
    </li>
  );
}

function OtherChoicesWithTitle() {
  return (
    <div className="list media-list block inset">
      <div className="list-group">
        <ul>
          <li className="list-group-title">Don’t see your location?</li>
        </ul>
        <OtherChoices/>
      </div>
    </div>
  );
}

function NoPagesView() {
  return (
    <div className="list media-list block inset no-pages-found">
      <p>There are no pages associated with your Facebook account.</p>
      <OtherChoices/>
    </div>
  );
}

function PageListFailedView() {
  return (
    <div className="list media-list block inset no-pages-found">
      <p>There was an error fetching the pages associated with your Facebook account.</p>
      <OtherChoices/>
    </div>
  );
}

function OtherChoices() {
  const FB = useFacebookClient();

  function signInWithDifferentAccount() {
    FB.logout(() => {
      FB.login(() => {}, { scope: 'manage_pages' });
    });
  }

  return (
    <p>
      <button className="button button-fill" onClick={signInWithDifferentAccount}>
        Sign in with a different account
      </button>
    </p>
  );
}
